import React, { useEffect, useState } from 'react';
import { ASSETS } from '../../utils/config';
import NotificationItem from '../../components/Notifications/NotificationItem';
import {
  Container,
  NotificationWrapper,
  TopBar,
  NotificationCount,
  LeftBar,
  IconButton,
} from './styles';
import { TextView } from '../../components';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import MarkAsUnreadIcon from '@mui/icons-material/MarkUnreadChatAlt';
import NotificationUnlock from '../../components/Notifications/NotificationModal/NotificationUnlock';
import NotificationClone from '../../components/Notifications/NotificationModal/NotificationClone';
import NotificationFavorite from '../../components/Notifications/NotificationModal/NotificationFavorite';
import NotificationUnlocked from '../../components/Notifications/NotificationModal/NotificationUnlocked';
import GalleryHeader from '../../components/WheelGallery/Header/GalleryHeader';
import Button from '../../components/Button';
import { getNotifications, markAllRead } from '../../services/api';
import { useDispatch, useSelector } from 'react-redux';
import {
  addNotifications,
  clearNewNotification,
  setNotifications,
} from '../../redux/reducers/notifications';
import NotificationsEmptyState from '../../components/Notifications/EmptyState';

function Notifications() {
  const dispatch = useDispatch();
  const [modalOpen, setModalOpen] = useState(null); // State to track which modal is open
  // const [notifications, setNotifications] = useState([]); // State to store notifications
  const notifications = useSelector((state) => state.notifications.data) ?? [];
  const [unreadCount, setUnreadCount] = useState(
    notifications.filter((notification) => !notification.is_read).length
  ); // State to track unread notification
  const [loading, setLoading] = useState(false); // State to track loading status
  const [page, setPage] = useState(1); // State to track current page
  const [hasNextPage, setHasNextPage] = useState(true); // State to track if there's a next page

  const handleOpenModal = (modalNumber) => {
    setModalOpen(modalNumber);
  };

  const handleCloseModal = () => {
    setModalOpen(null);
  };

  const handleMarkRead = async () => {
    // Mark all notifications as read
    // setNotifications((prevNotifications) =>
    //   prevNotifications.map((notification) => ({ ...notification, is_read: true }))
    // );
    try {
      const response = await markAllRead();
      console.log('Read response:', response);

      if (response.data && response.data.success) {
        console.log('success');
        dispatch(
          setNotifications(
            notifications.map((notification) => ({ ...notification, is_read: true }))
          )
        );
        setUnreadCount(0);
      } else {
        console.warn('/marking failed:', response.data);
      }
    } catch (error) {
      console.error('Error marking as read:', error.response ? error.response.data : error.message);
    }
  };

  const fetchNotifications = async (page) => {
    try {
      setLoading(true);
      const response = await getNotifications(page);
      const newNotifications = response.data.results;
      console.log('newNotifications:', newNotifications);
      // Append new notifications to the existing list
      // setNotifications((prevNotifications) => [...prevNotifications, ...newNotifications]);
      dispatch(addNotifications(newNotifications));
      // Update unread count
      const prevCount = unreadCount;
      const unread = newNotifications.filter((notification) => !notification.is_read).length;
      setUnreadCount(prevCount + unread);

      // Check if there's a next page
      setHasNextPage(response.data.next !== null);
    } catch (err) {
      console.error('Failed to fetch notifications:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleNextPage = () => {
    if (hasNextPage) {
      const nextPage = page + 1;
      setPage(nextPage);
      fetchNotifications(nextPage);
    }
  };
  return (
    <div style={{ height: '100vh', overflowY: 'auto' }}>
      <GalleryHeader />
      <div
        style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: 'auto' }}
      >
        <TopBar>
          <LeftBar>
            <TextView variant="subTitle" style={{ fontWeight: 'bold' }}>
              Notifications
            </TextView>
            <NotificationCount>{unreadCount}</NotificationCount>
          </LeftBar>

          {notifications?.length && <LeftBar>
            <TextView
              variant="largeText"
              style={{ fontWeight: '500', cursor: 'pointer' }}
              onClick={() => handleMarkRead()}
            >
              Mark all as read
            </TextView>
            <IconButton>
              <MoreVertIcon />
            </IconButton>
          </LeftBar>}
        </TopBar>

        {notifications?.length ?
          <>
            <Container>
              {notifications.map((notification) => (
                <NotificationWrapper key={notification?.id}>
                  <NotificationItem
                    name={notification?.name}
                    image={notification?.profile_picture}
                    wheel={notification?.image}
                    text={notification?.description || notification?.title}
                    type={notification?.instance_type}
                    wheelName={notification?.wheelName}
                    time={notification?.time_ago}
                    isUnread={!notification?.is_read}
                    wheelId={notification?.ref_id}

                  // wheel={notification.image}
                  />
                </NotificationWrapper>
              ))}
            </Container>
            <div style={{ display: 'flex', justifyContent: 'flex-start', marginBottom: '10px' }}>
              <Button onClick={handleNextPage} disabled={loading || !hasNextPage}>
                {loading ? 'Loading...' : 'See More'}
              </Button>
            </div>
          </>
          :
          <NotificationsEmptyState />

        }

        {modalOpen === 1 && <NotificationUnlock onClose={handleCloseModal} />}
        {modalOpen === 2 && <NotificationClone onClose={handleCloseModal} />}
        {modalOpen === 3 && <NotificationFavorite onClose={handleCloseModal} />}
        {modalOpen === 4 && <NotificationUnlocked onClose={handleCloseModal} />}
        {/* Show "More" button only if there's a next page */}
      </div>
    </div>
  );
}

export default Notifications;
